/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { jsonWebKeySetsGetDeletePreflight } from "../funcs/jsonWebKeySetsGetDeletePreflight.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { JSONWebKeySetDeletePreflight } from "../models/components/jsonwebkeysetdeletepreflight.js";
import {
  GetJsonWebKeySetDeletePreflightRequest,
  GetJsonWebKeySetDeletePreflightSecurity,
} from "../models/operations/getjsonwebkeysetdeletepreflight.js";
import { unwrapAsync } from "../types/fp.js";
export type JsonWebKeySetDeletePreflightQueryData =
  JSONWebKeySetDeletePreflight;

export function prefetchJsonWebKeySetDeletePreflight(
  queryClient: QueryClient,
  client$: GramCore,
  request: GetJsonWebKeySetDeletePreflightRequest,
  security?: GetJsonWebKeySetDeletePreflightSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildJsonWebKeySetDeletePreflightQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildJsonWebKeySetDeletePreflightQuery(
  client$: GramCore,
  request: GetJsonWebKeySetDeletePreflightRequest,
  security?: GetJsonWebKeySetDeletePreflightSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext,
  ) => Promise<JsonWebKeySetDeletePreflightQueryData>;
} {
  return {
    queryKey: queryKeyJsonWebKeySetDeletePreflight({
      id: request.id,
      gramSession: request.gramSession,
    }),
    queryFn: async function jsonWebKeySetDeletePreflightQueryFn(
      ctx,
    ): Promise<JsonWebKeySetDeletePreflightQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(jsonWebKeySetsGetDeletePreflight(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyJsonWebKeySetDeletePreflight(
  parameters: { id: string; gramSession?: string | undefined },
): QueryKey {
  return ["@gram/client", "jsonWebKeySets", "getDeletePreflight", parameters];
}
